import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { getCurrentYearInTimeZone } from "../../utils/dateUtil";
import { axiosPrivate } from "../../axios/axios";
import Loading from "../../Component/Loading";
import { masterAPI } from "../Masters/dataConfig";

const KPIHour = ({
  apiEndpoint,
  title = "KPI Hour",
  colors = ["#FF0000", "#008FFB"],
  legendColors = "black",
  xAxisLabelColor = "black",
}) => {
  const [series, setSeries] = useState({});
  const [loading, setLoading] = useState(true);
  console.log(apiEndpoint, "apiEndpoint");
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const currentYear = getCurrentYearInTimeZone();
      const response = await axiosPrivate.post(
        `${apiEndpoint}?year=${currentYear}`,
      );

      const apiData = response.data.result || response.data || [];
      setSeries(apiData);
    } catch (err) {
      setSeries({});
    } finally {
      setLoading(false);
    }
  };

  //   const chartHeight = series?.months.length > 5
  //   ? series?.calculative.length * 60
  //   : 350;

  //     const options = {
  //       chart: {
  //         height: chartHeight,
  //         type: "line",
  //         toolbar: {
  //             export: {
  //               csv: {
  //                 filename: title,
  //               },
  //               svg: {
  //                 filename: title,
  //               },
  //               png: {
  //                 filename: title,
  //               },
  //             },
  //           },
  //       },
  //        responsive: [
  //         {
  //           breakpoint: 1024,
  //           options: {
  //             chart: { height: 300 }
  //           }
  //         },
  //         {
  //           breakpoint: 768,
  //           options: {
  //             chart: { height: 250 }
  //           }
  //         }
  //       ],

  //       noData: {
  //         text: "No Data Available",
  //         align: "center",
  //         verticalAlign: "middle",
  //         style: {
  //           color: "#999",
  //           fontSize: "14px"
  //         }
  //       },

  //       title: {
  //         text: title,
  //         align: "center",
  //         style: { color: titleColor },
  //       },
  //       stroke: {
  //         width:  [0, 3],
  //       },
  //       dataLabels: {
  //         enabled: true,
  //       },
  //       labels: series?.months || [],
  //       colors: colors,
  //       yaxis: {
  //         labels: {
  //           formatter: (val) => val + "%"
  //         },
  //       },
  //       legend: {
  //         labels: {
  //           colors: legendColors,
  //         },
  //       },
  //       xaxis: {
  //         labels: {
  //           style: { colors: xAxisLabelColor },
  //         },
  //       },
  //     };

  //     const seriesData = [
  //       {
  //         name: "Average of Percentage Man Hour PM",
  //         type: "column",
  //         data: series?.calculative || []
  //       },
  //       {
  //         name: "Average of Target 40%",
  //         type: "line",
  //         data: series?.targetLine || []
  //       }
  //     ];

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <Chart
          options={{
            chart: {
              height: 350,
              type: "line",
              toolbar: {
                show: true,
                tools: {
                  download: true,
                  selection: false,
                  zoom: false,
                  zoomin: false,
                  zoomout: false,
                  pan: false,
                  reset: false,
                },
                export: {
                  csv: {
                    filename: title,
                  },
                  svg: {
                    filename: title,
                  },
                  png: {
                    filename: title,
                  },
                },
              },
            },
            responsive: [
              {
                breakpoint: 1024,
                options: {
                  chart: { height: 300 },
                },
              },
              {
                breakpoint: 768,
                options: {
                  chart: { height: 250 },
                },
              },
            ],

            noData: {
              text: "No Data Available",
              align: "center",
              verticalAlign: "middle",
              style: {
                color: "#999",
                fontSize: "14px",
              },
            },

            title: {
              text: title,
              style: {
                fontFamily: "Nunito Sans, sans-serif",
                color: "#2362B4",
              },
            },
            stroke: {
              width: [0, 3],
            },
            plotOptions: {
              bar: {
                borderRadius: 4,
                horizontal: false,
                dataLabels: {
                  position: "center",
                },
              },

              stroke: {
                width: 1,
                colors: ["#fff"],
              },
            },
            dataLabels: {
              enabled: true,
              enabledOnSeries: [0, 1],
              formatter: function (val) {
                return val + "%";
              },
              //    style: {
              //     //   fontSize: '12px',
              //     padding: "0px 4px",
              //       colors: ['#fff'], // Keep text white
              //       fontWeight: 'bold',
              //     },
              //     background: {
              //       enabled: false, // This removes the white background/border
              //     },
              //     dropShadow: {
              //       enabled: false // Also ensures no shadow remains
              //     }
            },
            labels: series?.months || [],
            colors: colors,
            yaxis: {
              labels: {
                formatter: (val) => val + "%",
              },
            },
            legend: {
              labels: {
                colors: legendColors,
              },
            },
            xaxis: {
              labels: {
                style: { colors: xAxisLabelColor },
              },
            },
          }}
          series={[
            {
              name: "Average of Percentage Man Hour",
              type: "column",
              data: series?.calculativeHours || [],
            },
            {
              name: `Average of Target ${series?.targetLine[0] || 40}%`,
              type: "line",
              data: series?.targetLine || [],
            },
          ]}
          type={"line"}
          height={350}
        />
      )}
    </>
  );
};

export default KPIHour;
